import { Navigate, Outlet } from "react-router-dom"

const AUTH_KEY = "authExpiry"

const isAuthenticated = (): boolean => {
  const expiryTimeString = localStorage.getItem(AUTH_KEY)
  if (!expiryTimeString) {
    return false
  }

  const expiryTime = parseInt(expiryTimeString, 10)
  if (isNaN(expiryTime)) {
    // Invalid timestamp stored
    localStorage.removeItem(AUTH_KEY) // Clean up invalid entry
    return false
  }

  const currentTime = new Date().getTime()
  if (currentTime > expiryTime) {
    // Auth expired
    localStorage.removeItem(AUTH_KEY) // Clean up expired entry
    return false
  }

  return true // Valid and not expired
}

const ProtectedRoute: React.FC = () => {
  if (!isAuthenticated()) {
    // User not authenticated or auth expired, redirect to password page
    return <Navigate to="/password" replace />
  }

  // User is authenticated, render the child routes
  return <Outlet />
}

export default ProtectedRoute
